import React from 'react';

const formatYears = value => {
  if (!value) return 'N/A';
  const num = parseFloat(value);
  if (Number.isNaN(num)) return value;
  return `${(num / 12).toFixed(1)} years`;
};

const cleanYear = value => {
  if (!value) return 'N/A';
  return value.replace?.('.0', '') || value;
};

const InfoBlock = ({ title, children }) => (
  <div className="bg-[#40414F] rounded-lg p-4">
    <h3 className="text-lg font-semibold text-white mb-3 flex items-center">{title}</h3>
    {children}
  </div>
);

const InfoRow = ({ label, value }) => (
  <div>
    <span className="text-gray-400 text-sm">{label}</span>
    <p className="text-white font-medium">{value || 'N/A'}</p>
  </div>
);

const MoreInfoModal = ({ isOpen, alumni, onClose }) => {
  if (!isOpen || !alumni) return null;
  const metadata = alumni.metadata || {};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-[#242831] rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">📋 Alumni Information</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="space-y-6">
          <InfoBlock title="👤 Basic Information">
            <div className="grid grid-cols-1 gap-3">
              <InfoRow label="Name:" value={metadata.new_name || alumni.name} />
              <InfoRow label="Position Summary:" value={metadata.vector_text || alumni.vector_text} />
            </div>
          </InfoBlock>
          <InfoBlock title="🎓 Education">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <InfoRow label="Graduation Year:" value={cleanYear(metadata.graduation_year || alumni.graduation_year || '')} />
              <InfoRow label="Most Recent School:" value={metadata.education_0_school || alumni.education_0_school} />
              <InfoRow label="Undergrad Degree:" value={metadata.school_degree || alumni.school_degree} />
              <InfoRow label="Highest Achieved Degree:" value={metadata.degree || alumni.degree} />
            </div>
          </InfoBlock>
          <InfoBlock title="💼 Current Position">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <InfoRow label="Title:" value={metadata.jobs_0_title || alumni.jobs_0_title} />
              <InfoRow label="Function:" value={metadata.jobs_0_function || alumni.jobs_0_function} />
              <InfoRow label="Duration:" value={formatYears(metadata.jobs_0_duration || alumni.jobs_0_duration)} />
              <InfoRow label="Company Tenure:" value={formatYears(metadata.jobs_0_company_tenure || alumni.jobs_0_company_tenure)} />
            </div>
          </InfoBlock>
          {(metadata.jobs_1_title || alumni.jobs_1_title || metadata.jobs_1_company_name || alumni.jobs_1_company_name) && (
            <InfoBlock title="📈 Previous Position">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <InfoRow label="Title:" value={metadata.jobs_1_title || alumni.jobs_1_title} />
                <InfoRow label="Company:" value={metadata.jobs_1_company_name || alumni.jobs_1_company_name} />
              </div>
            </InfoBlock>
          )}
          <InfoBlock title="🏢 Company Details">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <InfoRow label="Industry:" value={metadata.jobs_0_company_industry || alumni.jobs_0_company_industry} />
              <InfoRow label="Domain:" value={metadata.jobs_0_company_domain || alumni.jobs_0_company_domain} />
              <InfoRow label="Company Type:" value={metadata.jobs_0_company_type || alumni.jobs_0_company_type} />
              <InfoRow label="Employee Count:" value={cleanYear(metadata.jobs_0_company_employee_count || alumni.jobs_0_company_employee_count || '')} />
            </div>
          </InfoBlock>
        </div>
        <div className="mt-6 flex justify-end">
          <button onClick={onClose} className="px-6 py-2 bg-[#19C37D] text-white rounded-lg hover:bg-[#16A085] transition-colors">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export { MoreInfoModal };
